import React, { useEffect, useState } from 'react'

//MUI
import { Box, Typography } from '@mui/material'

const days = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
const months = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

const HourWidget = () => {

    const [date, setDate] = useState(new Date());

    useEffect(() => {
        const id = setInterval(() => setDate(new Date()), 1000);
        return () => clearInterval(id);
    }, []);

    const pad = (n) => String(n).padStart(2, "0");
    const hours = pad(date.getHours() % 12 || 12);
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    const ampm = date.getHours() >= 12 ? "p.m." : "a.m.";

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
            <Typography variant='body2' color="text.secondary" sx={{ fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", mb: 1.5, }}>
                Hora local
            </Typography>

            <Typography sx={{ fontFamily: 'sans-serif', fontSize: 36, fontWeight: 500, color: "#1a2035", letterSpacing: 1.5, lineHeight: 1, }}>
                {hours}:{minutes}:{seconds}
            </Typography>

            <Typography color="text.secondary" sx={{ fontSize: 22, fontWeight: 400, mt: 0.5, mb: 2 }}>
                {ampm}
            </Typography>

            <Typography variant='body2' color="text.secondary" sx={{ fontWeight: 500 }}>
                {days[date.getDay()]}
            </Typography>
            <Typography variant='body2' color="text.secondary">
                {date.getDate()} de {months[date.getMonth()]} {date.getFullYear()}
            </Typography>
        </Box>
    )
}

export default HourWidget